import * as React from 'react';
import { View, Text, StyleSheet,Dimensions } from 'react-native';
import { PropsDetails } from '../../types';
import  {themePattern}  from '../../constants/pattern';

import { aminoacidos } from '../../assets/aminoacidos';


const { width, height } = Dimensions.get('window')


export default function Details(props : PropsDetails ) {

    const { name, info } = aminoacidos(props.aminoAcid)
    return (
      <View  style={styles.container}>
          <View  style={styles.text}>
            
          <Text  style={styles.descrebePrimary}>{info[0]}</Text>
          <Text  style={styles.descrebeSecundary}>{info[1]}</Text>
        </View>
      </View>
    );
  }
  
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'space-between',
      padding: 20,
      backgroundColor:themePattern.desktop.white,
      borderRadius: 10,
      borderStyle: 'solid',
      borderColor:'black',
      borderWidth:2
    },
    descrebePrimary:{
        backgroundColor:themePattern.desktop.color1,
        color:themePattern.desktop.white,
        fontSize: width > 1200 ? themePattern.desktop.par2 : themePattern.tablet.par2,
        padding: 10,
        borderStyle: 'solid',
        borderColor:'black',
        borderWidth:2,
        borderRadius: 10

    }, 
    descrebeSecundary:{
        color: themePattern.desktop.black,
        fontSize:width > 1200 ? themePattern.desktop.par2 : themePattern.tablet.par3,
        marginTop: themePattern.desktop.retreat
        
    },
    text:{
        flexGrow:1,
        flex:1,
        justifyContent:'flex-start'
    }
  });
